(function () {
  'use strict';

  var scheduled = false;
  var bulgarianCookiePurpose = 'Удостоверяване на търговеца: основна бисквитка на търговеца.';
  var englishCookiePurpose = 'Merchant authentication: essential merchant cookie.';
  var knownImageDimensions = [
    { match: 'pandectes-banner-logo', width: 32, height: 32 },
    { match: 'shop-new-items-inline.jpg', width: 354, height: 704 },
    { match: 'POG_Set_Up_-_Gemplers_Distributor.jpg', width: 2340, height: 992 },
    { match: 'Shipping_Saver_Deal_Page_Banner.jpg', width: 2340, height: 992 }
  ];

  function humanizeHref(link) {
    var href = link.getAttribute('href') || '';
    var slug = href.split('#')[0].split('?')[0].split('/').filter(Boolean).pop() || '';
    try {
      slug = decodeURIComponent(slug);
    } catch (error) {
      // Keep the original slug when an invalid escape sequence is present.
    }
    return slug.replace(/[-_]+/g, ' ').replace(/\b\w/g, function (character) {
      return character.toUpperCase();
    });
  }

  function patchEmptyStretchedLinks() {
    document.querySelectorAll('a.stretched-link[aria-label=""]').forEach(function (link) {
      var card = link.closest('.card') || link.parentElement;
      var image = card && card.querySelector('img[alt]:not([alt=""])');
      var heading = card && card.querySelector('h1, h2, h3, h4, h5, h6');
      var label = (image && image.getAttribute('alt')) ||
        (heading && heading.textContent.trim()) ||
        humanizeHref(link);

      if (label) link.setAttribute('aria-label', label);
    });
  }

  function addButtonSemantics(control) {
    if (control.hasAttribute('href')) return;

    control.setAttribute('role', 'button');
    if (!control.hasAttribute('tabindex')) control.setAttribute('tabindex', '0');
    if (control.getAttribute('data-powermapper-keyboard') === 'true') return;

    control.setAttribute('data-powermapper-keyboard', 'true');
    control.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        control.click();
      }
    });
  }

  function patchSearchspringControls() {
    document.querySelectorAll('.ss__show-more__link, .utils-showby-item').forEach(addButtonSemantics);
  }

  function patchJunipRatingLinks() {
    document.querySelectorAll('.junip-product-summary [aria-label]:not([role])').forEach(function (element) {
      var label = element.getAttribute('aria-label') || '';
      if (!/stars?.*reviews?/i.test(label)) return;

      element.setAttribute('role', 'link');
      if (!element.hasAttribute('tabindex')) element.setAttribute('tabindex', '0');
      addButtonSemantics(element);
      element.setAttribute('role', 'link');
    });
  }

  function patchAppContent() {
    document.querySelectorAll('a[href][role="link"]').forEach(function (link) {
      link.removeAttribute('role');
    });

    document.querySelectorAll('dd').forEach(function (description) {
      if (description.textContent.trim() === bulgarianCookiePurpose) {
        description.textContent = englishCookiePurpose;
      }
    });

    document.querySelectorAll('img').forEach(function (image) {
      var source = image.currentSrc || image.getAttribute('src') || '';
      knownImageDimensions.forEach(function (dimensions) {
        if (source.indexOf(dimensions.match) === -1) return;
        image.setAttribute('width', String(dimensions.width));
        image.setAttribute('height', String(dimensions.height));
      });
    });
  }

  function runPatches() {
    scheduled = false;
    patchEmptyStretchedLinks();
    patchSearchspringControls();
    patchJunipRatingLinks();
    patchAppContent();
  }

  function schedulePatches() {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(runPatches);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runPatches);
  } else {
    runPatches();
  }

  new MutationObserver(schedulePatches).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
